/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import photo1 from "assets/images/logistique-1.jpg";
import photo2 from "assets/images/logistique-2.jpg";
import photo3 from "assets/images/logistique-3.jpg";
import photo4 from "assets/images/logistique-4.jpg";
import photo5 from "assets/images/logistique-5.jpg";
import photo6 from "assets/images/logistique-6.png";

export default [
  {
    title: "Location logistique évènementielle",
    description: "Une Logistique d'Exception pour des Évènements Inoubliables",
    items: [
      {
        image: photo1,
      },
      {
        image: photo2,
      },
      {
        image: photo3,
      },
      {
        image: photo4,
      },
      {
        image: photo5,
      },
      {
        image: photo6,
      },
    ],
  },
];
